import type { Command, CommandContext, CommandResult } from "./Command";

export class RenameDocumentCommand implements Command {
  readonly id = "document.rename";
  readonly label = "Rename Document";

  constructor(
    private readonly fromName: string,
    private readonly toName: string,
  ) {}

  execute(context: CommandContext): CommandResult {
    context.document.name = this.toName;
    return emptyResult();
  }

  undo(context: CommandContext): CommandResult {
    context.document.name = this.fromName;
    return emptyResult();
  }

  redo(context: CommandContext): CommandResult {
    return this.execute(context);
  }
}

function emptyResult(): CommandResult {
  return {
    changedNodeIds: [],
    affectedBounds: [],
  };
}
